// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3i-0";
export var eligibilityCardNotEligible = "_3i-1";